module.exports = __webpack_public_path__ + "media/images/logo/product-women-58968501e76a6e302f5479f0b0181cb1.png";